import { ModalGeneric } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import ProgramPointList from '../ProgramPointModal/ProgramPointList/ProgramPointList';
import useLocationProgramPoints from '../ProgramPointModal/useLocationProgramPoints';

const hasInvalidProgramPoint = (programPoint) =>
  programPoint?.code === null ||
  programPoint?.code === '' ||
  programPoint?.subCode === null ||
  programPoint?.subCode === '' ||
  programPoint?.cost === null ||
  programPoint?.cost === '' ||
  programPoint?.cost?.nombre === '' ||
  programPoint?.code?.nombre === '' ||
  programPoint?.subCode?.nombre === '' ||
  programPoint?.clasification === null ||
  programPoint?.clasification === '';

const AcceptModal = ({ show, onHide, ...props }) => {
  const { line, dateSelect, fetchData, editCSA, daily } = props;

  const {
    values,
    loading,
    setFieldValue,
    resetForm,
    getProgramPointsData,
    approveLocationProgramPoints
  } = useLocationProgramPoints({
    line
  });

  const [disablePrimaryAction, setDisablePrimaryAction] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const onExit = () => {
    onHide();
    fetchData();
    resetForm();
  };

  const hasRequiredProperties = (PP) =>
    Object.prototype.hasOwnProperty.call(PP, 'code') &&
    Object.prototype.hasOwnProperty.call(PP, 'subCode') &&
    Object.prototype.hasOwnProperty.call(PP, 'cost');

  const isProgramPointComplete = (pp, index, arrayLength) => {
    if (arrayLength === 1) {
      return pp.quantity !== '' && pp.quantity !== null;
    }
    if (index === 0) {
      return pp.quantity !== '' && pp.quantity !== null && pp.points !== '' && pp.points !== null;
    }

    return pp.quantity !== '' && pp.quantity !== null && pp.points !== '' && pp.points !== null;
  };

  useEffect(() => {
    const hasCompleteData = values.locations.every((location) =>
      location.programPoints.every(hasRequiredProperties)
    );

    const allProgramPointsComplete = values.locations
      .filter((location) => location?.habilitaVentana)
      .every((location) =>
        location.programPoints.every((pp, index) =>
          isProgramPointComplete(pp, index, location.programPoints.length)
        )
      );

    const hasInvalidProgramPointData = values.locations.some((location) =>
      location.programPoints.some(hasInvalidProgramPoint)
    );

    setDisablePrimaryAction(!allProgramPointsComplete);

    if (hasCompleteData) {
      setShowAlert(hasInvalidProgramPointData);
    } else {
      setShowAlert(true);
    }
  }, [values.locations]);

  useEffect(() => {
    if (show && line) getProgramPointsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, line]);

  const handlePostProgramPoints = async () => {
    await approveLocationProgramPoints(values?.locations);
    onExit();
  };

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={onExit}
      primaryAction={() => {
        handlePostProgramPoints();
      }}
      primaryActionDisabled={disablePrimaryAction}
      primaryActionLabel="Confirmar Aprobación"
      secondaryAction={onExit}
      secondaryActionLabel="Salir"
      show={show}
      size="xl"
      title="Datos operativos"
    >
      <ProgramPointList
        disabledInputPP
        disabledInputQuantity
        displayButtons={false}
        displayFixedlabel={false}
        editCSA={editCSA}
        eventoSigla={line?.eventoSigla}
        idParteDiario={line?.idParteDiario}
        isLocation
        line={line}
        loading={loading}
        selectedDate={dateSelect}
        setFieldValue={setFieldValue}
        showAlert={showAlert}
        showTitle
        showWarningOperationalData
        tipoAsignacion={daily?.tipoAsignacion}
        values={values}
        viewCSA
      />
    </ModalGeneric>
  );
};

export default AcceptModal;

AcceptModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  line: PropTypes.shape({
    eventoSigla: PropTypes.string,
    idParteDiario: PropTypes.number,
    puntosDeProgramaValues: PropTypes.arrayOf(
      PropTypes.shape({
        quantity: PropTypes.string,
        points: PropTypes.string,
        idPartePuntoPrograma: PropTypes.number,
        idParteDiario: PropTypes.number,
        code: PropTypes.shape({
          nombre: PropTypes.string
        }),
        subCode: PropTypes.shape({
          nombre: PropTypes.string
        }),
        cost: PropTypes.shape({
          nombre: PropTypes.string,
          costoClase: PropTypes.string,
          fase: PropTypes.string
        }),
        detail: PropTypes.string,
        clasification: PropTypes.shape({
          nombre: PropTypes.string
        })
      })
    ),
    cantidad: PropTypes.string
  }).isRequired,
  daily: PropTypes.shape({
    variosValoresOperativos: PropTypes.bool,
    codigoOperativo: PropTypes.bool,
    tipoAsignacion: PropTypes.number,
    numeroContrato: PropTypes.string,
    posicionSap: PropTypes.string,
    lineaSap: PropTypes.string,
    cantidad: PropTypes.string
  }).isRequired,
  onAccept: PropTypes.func,
  fetchData: PropTypes.func,
  editCSA: PropTypes.bool,
  dateSelect: PropTypes.string.isRequired
};

AcceptModal.defaultProps = {
  onAccept: () => {},
  fetchData: () => {},
  editCSA: false
};
